import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  Stack,
  IconButton,
  Alert,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { PRICING, paymentUrlWithPromo } from "../config/pricing";

function GradientDialogTitle({ title }) {
  return (
    <Box sx={{ pr: 5 }}>
      <Typography
        component="h2"
        sx={{
          fontSize: { xs: "1.35rem", sm: "1.7rem" },
          lineHeight: 1.15,
          fontWeight: 900,
          background: "linear-gradient(135deg, #7d9c14 0%, #5d770a 100%)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
}

function ModalShell({ open, onClose, title, children }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: fullScreen ? 0 : 2 } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 2,
          pb: 1.2,
        }}
      >
        <GradientDialogTitle title={title} />

        <IconButton
          onClick={onClose}
          aria-label="Popup schließen"
          sx={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            bgcolor: "action.hover",
            "&:hover": { bgcolor: "action.selected" },
          }}
        >
          <Typography sx={{ fontSize: 22, lineHeight: 1, color: "text.secondary" }}>
            ×
          </Typography>
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: { xs: 4, sm: 5, md: 5 } }}>
        {children}
      </DialogContent>
    </Dialog>
  );
}

export default function TokenExpiredDialog({
  open,
  onClose,
  salesUrl = paymentUrlWithPromo(),
}) {
  const handleExtend = () => {
    if (salesUrl) {
      window.location.href = salesUrl;
      return;
    }
    onClose?.();
  };

  return (
    <ModalShell open={open} onClose={onClose} title="Zugang abgelaufen">
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          Dein Token ist nicht mehr gueltig. Verlaengere jetzt deinen Zugang, um den
          Media-Kit Generator weiter zu nutzen.
        </Typography>

        <Alert severity="warning" variant="outlined">
          <Typography variant="body2">
            Nach dem Kauf bekommst du einen neuen Zugangslink, der wieder für den
            gesamten Zeitraum freigeschaltet ist.
          </Typography>
        </Alert>

        <Button onClick={handleExtend} variant="contained" fullWidth color="primary" sx={{ py: 1.2 }}>
          Zugang verlängern
        </Button>
      </Stack>
    </ModalShell>
  );
}
